import { useQueries } from '@tanstack/react-query';
import { LookupEntity } from 'pco-product-service-internal-consumer';
import { getDropdown } from 'services/portfolios/portfolioService';

//TODO: This is a temporary setup to provide the more popular options for cash account type, to be removed after BE api has been updated for this
const PRIORITY_CASH_ACCOUNT_TYPE_KEYS = [
  '1220',
  '2120',
  '2122',
  '2124',
  '2162',
  '2220',
  '7011',
  '7013',
  '7061',
  '7062',
  '8320',
  '8325',
  '9011',
  '9021',
];

const prioritizeCashAccountTypes = (data: LookupEntity[]): LookupEntity[] => {
  const priority = data
    .filter((item) => PRIORITY_CASH_ACCOUNT_TYPE_KEYS.includes(item.key))
    .sort((a, b) => PRIORITY_CASH_ACCOUNT_TYPE_KEYS.indexOf(a.key) - PRIORITY_CASH_ACCOUNT_TYPE_KEYS.indexOf(b.key));
  const others = data.filter((item) => !PRIORITY_CASH_ACCOUNT_TYPE_KEYS.includes(item.key));
  return [...priority, ...others];
};

export const useGetDropdown = () => {
  const [
    currency,
    portfolioStatus,
    portfolioType,
    cashAccountType,
    servicingRoleType,
    portfolioLinkType,
    externalAccountIdentifierType,
  ] = useQueries({
    queries: [
      {
        queryKey: ['currency'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('currency'),
      },
      {
        queryKey: ['portfolioStatus'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('portfoliostatus'),
      },
      {
        queryKey: ['portfolioType'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('portfoliotype'),
      },
      {
        queryKey: ['cashAccountType'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('cashaccounttype'),
        select: prioritizeCashAccountTypes,
      },
      {
        queryKey: ['servicingRoleType'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('portfolioservicingroletype'),
      },
      {
        queryKey: ['portfolioLinkType'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('portfolioLinkType'),
      },
      {
        queryKey: ['externalAccountIdentifierType'],
        queryFn: (): Promise<LookupEntity[]> => getDropdown('externalAccountIdentifierType'),
      },
    ],
  });

  return {
    currencyData: currency.data,
    portfolioStatusData: portfolioStatus.data,
    portfolioTypeData: portfolioType.data,
    cashAccountTypeData: cashAccountType.data,
    servicingRoleTypeData: servicingRoleType.data,
    portfolioLinkTypeData: portfolioLinkType.data,
    externalAccountIdentifierTypeData: externalAccountIdentifierType.data,

    isLoading:
      currency.isLoading ||
      portfolioStatus.isLoading ||
      portfolioType.isLoading ||
      cashAccountType.isLoading ||
      servicingRoleType.isLoading ||
      portfolioLinkType.isLoading ||
      externalAccountIdentifierType.isLoading,
  };
};
